import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { sa_NoticeReader } from "Constants/TableColumns";

function NoticeReader({ row }) {
  const [showDialog, setShowDialog] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [tblData, setTblData] = useState([]);
  const { direction } = useTheme();

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    setLoading(true);
    const response = await NotificationsService.getNotificationsReader({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      Id: row.Id,
    });
    let err = StatusHandler(response);
    if (!err.isFail) {
      setTblData(response.data.Value);
    }
    setLoading(false);
  };

  const onExit = async () => {
    setShowDialog(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="notice_reader" />}
        icon={<Icons.People size={20} />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>
            <span>{row.Title}</span>
          </p>
        </div>
        <DialogContent>
          <BackDropLoading loading={Loading} />
          <Grid container spacing={2}>
            <RemoteTable
              data={tblData}
              columns={sa_NoticeReader}
              showPagination={false}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={onExit} title={<Translator id="enseraf" />} />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NoticeReader;
